module.exports = function () {
    if ($('.careers-inline-search').length) {
        var $careersTypeAheadContainer = $('.careers-inline-search__type-ahead-container');

        var filledClass = 'careers-inline-search-fields-filled';

        $('.careers-inline-search-fields input').keyup(function () {
            if ($(this).val().length) {
                $(this).closest('.careers-inline-search-fields-keywords').addClass(filledClass);
            } else {
                $(this).closest('.careers-inline-search-fields-keywords').removeClass(filledClass);
            }
        });

        $('.careers-inline-search-field-clear').click(function () {
            $(this).siblings('input').val('').focus();
            $(this).closest('.careers-inline-search-fields-keywords').removeClass(filledClass);

            var $typeAheadHidden = $careersTypeAheadContainer.find('.type-ahead-hidden');
            var $typeAheadVisible = $careersTypeAheadContainer.find('.type-ahead-visible');

            $typeAheadHidden.text('');
            $typeAheadVisible.text('');
        });

        var autoComplete;

        ICF.Utils.LoadScript('https://maps.googleapis.com/maps/api/js?key=' + window.ICFGoogleMapsKey + '&libraries=places', function () {
            autoComplete = new google.maps.places.Autocomplete($('#location')[0], {
                types: ['(regions)']
            });
        });        
    }
};